'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _gt2 = require('lodash/gt');
var _gt3 = _interopRequireDefault(_gt2);
exports.default = eauors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _utils = require('../utils/');
var utils = _interopRequireWildcard(_utils);
var _constants = require('../utils/constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function backgroundEnter(selection, selector, selectors) {
  selection.insert('svg:rect', ':first-child').classed(selector, true);
}
function backgroundUpdate(selection, options, el, selectors) {
  var xAxisOrient = options.axis.x.orient;
  var xAxisTickSize = options.axis.x.tick.size;
  var xAxis = _d2.default.select(el).select(utils.selector(selectors.xAxis));
  var xAxisHeight = xAxis.empty() ? 0 : utils.getElementDimensions(xAxis).height;
  var height = xAxisOrient === _constants.BOTTOM ? options.base.height - xAxisHeight - ((0, _gt3.default)(xAxisTickSize, 0) ? 0 : xAxisTickSize) : options.base.height;
  selection.attr({
    width: options.base.width,
    height: (0, _gt3.default)(height, 0) ? height : 0
  }).style({
    fill: options.background.color
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    backgroundEnter: backgroundEnter,
    backgroundUpdate: backgroundUpdate
  });
}